import React from "react";

export function Skills() {
  return (
    <section id="skills" className="py-5">
      <div className="container">
        <h2 className="text-center mb-4">Skills</h2>

        <div className="row">
          {/* Technical Skills */}
          <div className="col-md-6 mb-4">
            <h4 className="fw-bold">💻 Tech & Tools</h4>
            <ul className="list-group">
              <li className="list-group-item">HTML5</li>
              <li className="list-group-item">CSS3</li>
              <li className="list-group-item">JavaScript</li>
              <li className="list-group-item">Bootstrap</li>
              <li className="list-group-item">Git & GitHub</li>
            </ul>
          </div>

          {/* Learning Skills */}
          <div className="col-md-6 mb-4">
            <h4 className="fw-bold">⚛️ Currently Learning</h4>
            <ul className="list-group">
              <li className="list-group-item">React</li>
              <li className="list-group-item">Responsive Design</li>
              <li className="list-group-item">API Integration</li>
            </ul>
          </div>

          {/* Soft Skills */}
          <div className="col-12">
            <h4 className="fw-bold">🚀 Soft Skills</h4>
            <ul className="list-group">
              <li className="list-group-item">Problem-Solving</li>
              <li className="list-group-item">Communication</li>
              <li className="list-group-item">Adaptability</li>
              <li className="list-group-item">Teamwork</li>
              <li className="list-group-item">Creativity & Curiosity</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
